//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mdiArrowRight, mdiArrowLeft } from '@mdi/js'

export default {
  setup() {
    return {
      icons: {
        mdiArrowRight,
        mdiArrowLeft,
      },
    }
  },
}
